export default {
    symplaTokenOptions: function() {
        return this.symplaTokens.map(token => {
            return {
                label: `${token.name} (${token.token})`,
                value: token['@id']
            }
        })
    }
}
